<template>
  <view class="checkbox-group-slot-demo">
    <view class="cube-checkbox-group-example">
      <cube-checkbox-group
        wx:model="{{ checkedValues }}"
        wx:model-prop="values"
        bind:checked="onChecked"
        bind:cancelChecked="onCancelChecked"
      >
        <cube-checkbox
          wx:for="{{ options }}"
          wx:for-item="option"
          wx:for-index="index"
          wx:key="index"
          option="{{ option }}"
        ></cube-checkbox>
      </cube-checkbox-group>
    </view>
    <view class="view-desc">选中 value 值：{{ checkedValues }}</view>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    options: {
      styleIsolation: 'shared'
    },
    data: {
      checkedValues: ['2'],
      options: [
        {
          value: '1',
          text: '1'
        },
        {
          value: '2',
          text: '2'
        },
        {
          value: '3',
          text: '3'
        }
      ]
    },
    methods: {
      onChecked (e) {
        const { value } = e.detail
        console.log('选中操作：', value)
      },
      onCancelChecked (e) {
        const { value } = e.detail
        console.log('取消选中操作：', value)
      }
    }
  })
</script>

<style lang="stylus">
.cube-checkbox-example
  padding 5px 10px
  background-color #fff
.desc
  margin-top 15px
</style>

<script type="application/json">
{
  "styleIsolation": "shared",
  "usingComponents": {
    "cube-checkbox-group": "@mpxjs/mpx-cube-ui/src/components/checkbox-group/index.mpx",
    "cube-checkbox": "@mpxjs/mpx-cube-ui/src/components/checkbox/index.mpx"
  }
}
</script>
